import React, { useState, useEffect,useContext } from "react";
import { UserContext } from "../context/UserContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Header.css";
import "../css/SearchDropdown.css";
import logo from '../images/logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
  faShoppingCart,
  faSearch,
  faUser,
  faBars,
  faTimes,
  faUserGraduate,
  faCertificate,
  faCaretDown,
  faIdCard,
  faFileSignature,
  faMoneyBillWave,
  faHistory,
  faUniversity,
  faUsers,
  faChartBar,
  faSignOutAlt,
  faTruck,
  faSeedling,
  faWarehouse,
  faPlaneDeparture,
  faBoxes,
  faShieldAlt,
  faTruckLoading,
  faTruckFast,
  faRoute,
  faHandshake,
  faShieldHalved,
  faDiagramProject,
  faGlobe,
  faShip,
  faBuildingCircleCheck,
  faAnchor,
  faTractor,
  faBoxesStacked,
  faBox,
  faFileAlt,
  faHome
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl, courseSearch, getCartDetails, screenPermissionDetails } from "../Services/Api";

const iconMap = {
  faUser: faUser,
  faUserGraduate: faUserGraduate,
  faTruck: faTruck,
  faSeedling: faSeedling,
  faWarehouse: faWarehouse,
  faPlaneDeparture: faPlaneDeparture,
  faBoxes: faBoxes,
  faShieldAlt: faShieldAlt,
  faTruckLoading: faTruckLoading,
  faTruckFast: faTruckFast,
  faRoute: faRoute,
  faHandshake: faHandshake,
  faShieldHalved: faShieldHalved,
  faDiagramProject: faDiagramProject,
  faGlobe: faGlobe,
  faShip: faShip,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faAnchor: faAnchor,
  faTractor: faTractor,
  faBoxesStacked: faBoxesStacked,
  faShoppingCart: faShoppingCart,
  faBox: faBox,
  faFileAlt: faFileAlt,
  faHome: faHome
};

const Navbar = () => {
    const { user, isLoggedIn, authorizedScreen, cartCount } = useContext(UserContext);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [enrolledCount, setEnrolledCount] = useState(0);
  const [certifiedCount, setCertifiedCount] = useState(0);
  // const [cartCount, setCartCount] = useState(0);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [authorizedScreen, setAuthorizedScreen] = useState([]);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  // const [user, setUser] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // ---------------- LOGOUT ----------------
  async function handleLogout() {
    try {
      await fetch(`${BaseUrl}/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("Logout failed", err);
    } finally {
      // setIsLoggedIn(false);
      // setUser(null);
      setIsProfileDropdownOpen(false);
      // navigate("/login");
      window.location.href = "/login";
    }
  }

  // Dropdown items
  const profileDropdownItems = [
    ...(authorizedScreen && authorizedScreen.length > 0
      ? authorizedScreen.map((screen, index) => ({
        id: index,
        path: "/" + screen.url,
        icon: iconMap[screen.font_icon] || faUser,
        text: screen.screen_name,
      }))
      : []),
    {
      id: 999,
      path: null,
      icon: faSignOutAlt,
      text: "Logout",
      onClick: handleLogout,
    },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isSearchVisible) setIsSearchVisible(false);
  };

  const toggleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
    if (isMenuOpen) setIsMenuOpen(false);
    if (isSearchVisible) {
      setSearchQuery("");
      setSearchResults([]);
    }
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  // ---------------- CHECK LOGIN (via cookie) ----------------
  useEffect(() => {
    async function checkAuth() {
      try {
        const res = await fetch(`${BaseUrl}/me`, {
          method: "GET",
          credentials: "include",
        });

        if (res.ok) {
          const data = await res.json();
          if (data.user) {
            // console.log(data.user.id);
            // setIsLoggedIn(true);
            // setUser(data.user);
          } else {
            // setIsLoggedIn(false);
            // setUser(null);
            navigate('/');
          }
        } else {
          // setIsLoggedIn(false);
          // setUser(null);
        }
      } catch (err) {
        console.error("Auth check failed", err);
        // setIsLoggedIn(false);
        // setUser(null);
      }
    }
    checkAuth();
  }, []);

  // ---------------- SCREEN PERMISSIONS ----------------
  useEffect(() => {
    if (!user) return; // run only if user exists

    const screenCheck = async () => {
      try {
        const screen = await screenPermissionDetails();
        // console.log("Screen permissions:", screen);
        // setAuthorizedScreen(screen.data || []);
      } catch (err) {
        console.error("Screen check failed", err);
      }
    };

    screenCheck();
  }, [user]);

  // ---------------- SEARCH ----------------
  const handleSearch = async (e) => {
    const keyWords = e.target.value;
    setSearchQuery(keyWords);

    if (keyWords.length < 2) {
      setSearchResults([]);
      return;
    }

    try {
      const response = await courseSearch(keyWords);
      if (response && response.course) {
        setSearchResults(response.course.slice(0, 5));
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.log("Search Err", err);
      setSearchResults([]);
    }
  };

  useEffect(() => {
    getCartDetails()
      .then((data) => {
        // setCartCount(data.data.length);
        // console.log(data.data.length);


      })
      .catch((error) => {
        console.error("Error fetching cart details:", error);

      });
    const handleClickOutside = (event) => {
      if (!event.target.closest(".search-container")) {
        setSearchResults([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };


  }, []);

  // ---------------- COUNTERS ----------------
  useEffect(() => {
    const targetEnrolled = 12500;
    const targetCertified = 8500;
    const duration = 2000;
    const increment = 50;

    const enrolledSteps = Math.ceil(duration / increment);
    const certifiedSteps = Math.ceil(duration / increment);

    const enrolledIncrement = Math.ceil(targetEnrolled / enrolledSteps);
    const certifiedIncrement = Math.ceil(targetCertified / certifiedSteps);

    const enrolledInterval = setInterval(() => {
      setEnrolledCount((prev) => {
        if (prev >= targetEnrolled) {
          clearInterval(enrolledInterval);
          return targetEnrolled;
        }
        return prev + enrolledIncrement;
      });
    }, increment);

    const certifiedInterval = setInterval(() => {
      setCertifiedCount((prev) => {
        if (prev >= targetCertified) {
          clearInterval(certifiedInterval);
          return targetCertified;
        }
        return prev + certifiedIncrement;
      });
    }, increment);

    return () => {
      clearInterval(enrolledInterval);
      clearInterval(certifiedInterval);
    };
  }, []);

  return (
    <nav className="main-navbar">
      <div className="container-fluid">
        <div className="nav-content">
          {/* Logo */}
          <div className="logo">
            <img
              src={logo}
              alt="lsc logo"
              className="com-logo"
            />
          </div>

          {/* Home Link - Placed after the logo */}
          <Link to="/" className="home-link">
            <FontAwesomeIcon icon={faHome} className="home-icon" />
            <span>Home</span>
          </Link>

          {/* Search */}
          <div
            className={`search-container ${isSearchVisible ? "mobile-visible" : ""
              }`}
          >
            <div className="search">
              <input
                type="search"
                className="search-input"
                placeholder="Search courses..."
                value={searchQuery}
                onChange={handleSearch}
              />
              <FontAwesomeIcon icon={faSearch} className="search-icon" />

              {searchResults.length > 0 && (
                <div className="search-results-dropdown">
                  {searchResults.map((course) => (
                    <Link
                      to={`/category/${course.all_course_id}`}
                      key={course.all_course_id}
                      className="search-result-item"
                      onClick={() => {
                        setSearchResults([]);
                        setSearchQuery("");
                      }}
                    >
                      <div className="search-result-image">
                        {course.image ? (
                          <img
                            src={`${BaseUrl}/${course.image}`}
                            alt={course.course_name}
                          />
                        ) : course.logo ? (
                          <FontAwesomeIcon
                            icon={iconMap[course.logo]}
                            className="course-logo"
                            style={{ color: course.color }}
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faBox}
                            className="course-logo"
                            style={{ color: "purple" }}
                          />
                        )}
                      </div>
                      <div className="search-result-info">
                        <div className="search-result-title">
                          {course.course_name
                            .toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                          {/* {course.course_name} */}
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Actions */}
          <div className={`nav-actions ${isMenuOpen ? "mobile-visible" : ""}`}>
            <div className="action-buttons">
              <Link to="/cart">
                {
                  cartCount > 0 ? (
                    <Badge
                      badgeContent={cartCount}
                      sx={{
                        '& .MuiBadge-badge': {
                          backgroundColor: '#7892F7',
                          color: 'white',
                        },
                      }}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />
                    </Badge>

                  ) : (

                    <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />

                  )
                }

                {/* <Badge badgeContent={4} color="primary">
                  <ShoppingCartIcon color="action" className="cart-icon"/>
                </Badge> */}
              </Link>

              {!isLoggedIn ? (
                <>
                  <button className="btn-signup">
                    <Link to="/register">
                      <span>Sign Up</span>
                    </Link>
                  </button>
                  <Link to="/login" className="btn-login dummy-color">
                    <FontAwesomeIcon icon={faUser} className="user-icon" />
                    <span>Login</span>
                  </Link>
                </>
              ) : (
                <div className="profile-dropdown-container">
                  <div className="profile-icon" onClick={toggleProfileDropdown}>
                    <img
                      src={
                        user?.avatar ||
                        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQvuzfr2gc02lHszMDqsuW2_d0htAmeJKJguA&s"
                      }
                      alt="Profile"
                      className="profile-image"
                    />
                    <FontAwesomeIcon
                      icon={faCaretDown}
                      className="dropdown-arrow"
                    />
                  </div>
                  {isProfileDropdownOpen && (
                    <div className="profile-dropdown">
                      {profileDropdownItems.map((item) =>
                        item.path ? (
                          <Link
                            to={item.path}
                            key={item.id}
                            onClick={() => setIsProfileDropdownOpen(false)}
                          >
                            <div className="dropdown-item">
                              <FontAwesomeIcon
                                icon={item.icon}
                                className="drop-icon"
                              />
                              <span>{item.text}</span>
                            </div>
                          </Link>
                        ) : (
                          <div
                            className="dropdown-item"
                            key={item.id}
                            onClick={item.onClick}
                          >
                            <FontAwesomeIcon icon={item.icon} />
                            <span>{item.text}</span>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Mobile controls */}
          <div className="mobile-controls">
            <button className="mobile-search-btn" onClick={toggleSearch}>
              <FontAwesomeIcon icon={faSearch} />
            </button>
            <button className="hamburger" onClick={toggleMenu}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;